@if (gridConfig.gridName === 'TradeReviewGrid') {
  <button
    type="button"
    mat-button
    color="primary"
    class="header-button"
    matTooltip="Downloads all interactions (approvals, notes, etc) for each selected transaction"
    matTooltipPosition="above"
    [matTooltipShowDelay]="1000"
    [disabled]="
      (selectedRecords.length <= 0 || selectedRecords.length > 1000) &&
      !bulkSelect
    "
    (click)="downloadGridReport(true)"
  >
    <mat-icon>system_update_alt</mat-icon>
    Download Audit Report
  </button>
}

<button
  type="button"
  mat-button
  color="primary"
  class="grid-button header-button"
  matTooltipPosition="above"
  [matTooltip]="
    gridConfig.downloadGridButtonProps?.payloadOverride
      ? formatRecordLimit(
          gridConfig.downloadGridButtonProps?.payloadOverride?.take
        )
      : ''
  "
  (click)="downloadGridReport()"
>
  <div class="download-grid-button">
    @if (fileLoading) {
      <span class="download-grid-button-label-with-icon">
        <mat-spinner diameter="20" />
        {{ gridConfig.downloadGridButtonProps?.text || 'Download Grid Data' }}
      </span>
    } @else {
      @if (gridConfig.downloadGridButtonProps?.icon) {
        @if (gridConfig.downloadGridButtonProps.icon !== 'NONE') {
          <mat-icon class="me-1">
            {{ gridConfig.downloadGridButtonProps.icon }}
          </mat-icon>
        }
      } @else {
        <mat-icon class="me-1">cloud_download</mat-icon>
      }
      {{ gridConfig.downloadGridButtonProps?.text || 'Download Grid Data' }}
    }
  </div>
</button>
